// extracted by mini-css-extract-plugin
module.exports = {"title":"List_title__fTyE5","listSection":"List_listSection__3YBic","list":"List_list__30PRf","subList":"List_subList__2lpn1 List_list__30PRf"};